module.exports = __webpack_public_path__ + "static/media/cloudy.300ed1bb.svg";